<template>
  <div class="container-fluid">
    <page-header :page="page" />
    <squareOption :menu="optionList" />

    <label style="font-size: 16px">
      16 px
    </label>
    <br />
    <label>
      14 px
    </label>
  </div>
</template>

<script>
import store from '@/store/index';
import squareOption from '@/components/common/menu/SquareOption';
import PageHeader from 'PageHeader';
// import navMenuTitles from "@/utils/constants/navMenuTitles";

export default {
  components: {
    squareOption,
    PageHeader,
  },
  computed: {
    hasSelectedStudent() {
      return store.getters.IsValidSelectedStudent;
    },
    optionList() {
      return [
        {
          route: '/shared/Manage',
          mainImage: 'icon_manejo_de_referidos.svg',
          hoverImage: 'icon_manejo_de_referidos_over.svg',
          title: 'Enlace utilizado para el ejemplo de la Manejo.',
          detail: 'Enlace utilizado para el ejemplo de la Manejo.',
          canNavigate: this.validateStudent,
        },
        {
          route: '/shared/Order',
          mainImage: 'icon_manejo_de_referidos.svg',
          hoverImage: 'icon_manejo_de_referidos_over.svg',
          title: 'Pedido',
          detail: 'Ejemplo de Pedido',
          canNavigate: this.validateStudent,
        },
      ];
      // return store.getters.getUserSitemap
      //   .find(x => x.title === navMenuTitles.Books)
      //   .children.map(item => ({
      //     title: item.title,
      //     description: item.description,
      //     detail: item.detail,
      //     icon: item.iconClasses,
      //     mainImage: item.mainImagePath,
      //     hoverImage: item.mainImageHoverPath,
      //     needSelectedStudent: item.needSelectedStudent,
      //     route: item.navigationPath
      //   }));
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-book-open',
        title: 'Shared',
        routes: ['Inicio', 'Shared'],
      },
    };
  },
  methods: {
    async validateStudent(option) {
      if (!store.getters.IsValidSelectedStudent && option.needSelectedStudent) {
        store.commit('setWebServiceStudentSearchEnabled', false);
        store.commit('$_student/toggleSearchMenu');
        store.commit('setNavigationToViewRoute', option.route);
        this.$store.commit(
          '$_student/showStudentBox',
          option.needSelectedStudent
        );
        return false;
      }

      return true;
    },
  },
};
</script>
<style scoped>
.flip-cards-container {
  display: flex;
  flex-wrap: wrap;
}

.flip-cards-container > div {
  min-height: 200px;
  min-width: 200px;
}
</style>
